import { createSlice } from '@reduxjs/toolkit';
import { getReportFromPatientIdApi } from '../../../rtk-apis/reports/getReportFromPatientId';

const initialState = {
  status: '',
  result: [],
  msg: '',
  loading: false,
};

const getReportFromPatientIdSlice = createSlice({
  name: 'Get Report Fromt Patient Id',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getReportFromPatientIdApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getReportFromPatientIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg;
        state.result = action?.payload?.result;
      })
      .addCase(getReportFromPatientIdApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
        state.result = [];
      });
  },
});

export const { clearState } = getReportFromPatientIdSlice.actions;
export default getReportFromPatientIdSlice.reducer;
